<template>
  <span class="terminal">
    <div class="terminal-item" />
    <div class="terminal-item" />
    <div class="terminal-item" />
    <div class="terminal-item" />
    <div class="terminal-item" />
    <div class="terminal-item" />
    <div class="terminal-item" />
    <div class="terminal-item blinking" />
  </span>
</template>

<script>
export default {
  name: 'terminal'
}
</script>

<style lang="scss" scoped>
.terminal {
  border: 3px solid #42b983;
  border-radius: 5px;
  width: 100%;
  .terminal-item {
    height: 14px;
    background: #42b983;
    margin: 10px;
    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 60%;
    }
    &:nth-child(3) {
      width: 45%;
    }
    &:nth-child(4) {
      width: 80%;
    }
    &:nth-child(5) {
      width: 10%;
    }
    &:nth-child(6) {
      width: 23%;
    }
    &:nth-child(7) {
      width: 28%;
    }
    &:nth-child(8) {
      width: 5px;
    }
  }
}

.blinking {
  animation: blinkingText 1s infinite;
}
@keyframes blinkingText {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
